/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=e12258bc&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=e12258bc&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=e12258bc&lang=scss"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12258bc"],['__file',"library/components/VabMenu/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e12258bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e12258bc', __exports__)) {
    api.reload('e12258bc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e12258bc&scoped=true&ts=true", () => {
    api.rerender('e12258bc', render)
  })

}


export default __exports__